import React from 'react'

export const modalInstallRef = React.createRef()
